module.exports = __webpack_public_path__ + "img/hr-rock-small-07.83667d7c.png";